// extracted by mini-css-extract-plugin
export default {"item":"Registration_item__OhjKP","navLinkActive":"Registration_navLinkActive__As-nx"};